var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"XLautomobile"},[_c('div',{attrs:{"id":"container"}}),_c('div',{staticClass:"box"},[_vm._m(0),_c('div',{ref:"arrow",staticClass:"arrow-up",on:{"click":_vm.hanleaboutUs}},[_c('span'),_c('span')])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-text"},[_c('p',[_vm._v("浦创智能")]),_c('h4',[_vm._v("引领新一代驾乘体验的智能座舱一体化供应商")])])
}]

export { render, staticRenderFns }